import { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";

const GameImage = ({ gameId, gameImg }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		setCurrentIndex(0);
		setLoaded(false);
	}, [gameId, gameImg]);

	if (gameImg) {
		return (
			<LazyLoad height={200} offset={300} overflow once>
				<img src={gameImg} alt="Game" className="game-image loaded" />
			</LazyLoad>
		);
	}

	if (!gameId) return null;

	const hostname = window.location.hostname;

	const imageHost = [
		"localhost",
		"new.fgh.fun",
		"new.fgh.cool",
		"new.thefgh.fun",
	].includes(hostname)
		? "https://fgh.zone"
		: window.location.origin;

	const substringLengths = [2, 3];

	const fallbackImages = substringLengths.flatMap((len) => {
		const folder = String(gameId).substring(0, len);

		const baseApiUrl = `${imageHost}/json/resources/images/WLP/${folder}/${gameId}`;

		const dimensionApiUrl = `${imageHost}/json/resources/images/WLP/${folder}/200x200/${gameId}`;

		return [
			`${baseApiUrl}.jpg`,
			`${baseApiUrl}.png`,
			`${baseApiUrl}.gif`,

			`${dimensionApiUrl}.jpg`,
			`${dimensionApiUrl}.png`,
			`${dimensionApiUrl}.gif`,
		];
	});

	const handleImageError = () => {
		setLoaded(false);

		setCurrentIndex((prevIndex) =>
			prevIndex + 1 < fallbackImages.length ? prevIndex + 1 : prevIndex,
		);
	};

	const handleImageLoad = () => {
		setLoaded(true);
	};

	return (
		<LazyLoad height={200} offset={300} overflow once>
			<img
				key={`${gameId}-${currentIndex}`}
				src={fallbackImages[currentIndex]}
				alt="Game"
				onError={handleImageError}
				onLoad={handleImageLoad}
				className={`game-image ${loaded ? "loaded" : ""}`}
			/>
		</LazyLoad>
	);
};

export default GameImage;
